
import ElementPlus from "../../../assets/duotone/ElementPlus.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ElementPlusIcon({ className, dataTestid = "ElementPlusIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ElementPlus data-testid={dataTestid} className={classes} {...rest} />
  );
}
